import React, { useEffect, useState } from "react";
import { Button, Box, CircularProgress } from "@mui/material";
import { ShopifyAppConfigService } from "../../utils/services/shopify-app-config-service";
import DashboardContainer from "../../components/dashboard-container";
import ShopifyAppConfigList from "../../components/shopify-config-list";
import ShopifyConfigCreateModal from "../../components/shopify-config-create-modal";

const ShopifyAppConfig = () => {
  const [open, setOpen] = useState(false);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [dataCount, setDataCount] = useState(rowsPerPage);
  const [shopifyConfigData, setShopifyConfigData] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const fetchConfigData = async () => {
    setLoading(true);
    try {
      const response = await ShopifyAppConfigService.fetch(
        rowsPerPage,
        rowsPerPage * page,
      );
      setShopifyConfigData(response.data);
      setDataCount(response.total);
    } catch (error) {
      console.error("Fetch failed:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchConfigData();
  }, [page, rowsPerPage]);

  return (
    <div>
      <DashboardContainer
        headerButtons={
          <Box display="flex" justifyContent="flex-end">
            <Button variant="contained" color="primary" onClick={handleOpen}>
              + New Config
            </Button>
          </Box>
        }
        header="Shopify Config List"
        hideUploadButton
        hideFilterClient
        hideAddButton
        manifest
      >
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 9999,
            }}
          >
            <CircularProgress color="inherit" />
          </Box>
        ) : (
          <ShopifyAppConfigList
            setRowsPerPage={setRowsPerPage}
            onDeleteSuccess={fetchConfigData}
            dataCount={dataCount}
            page={page}
            rowsPerPage={rowsPerPage}
            setPage={setPage}
            data={shopifyConfigData}
          />
        )}
      </DashboardContainer>

      <ShopifyConfigCreateModal
        open={open}
        onClose={handleClose}
        onCreated={fetchConfigData}
        setLoading={setLoading}
      />
    </div>
  );
};

export default ShopifyAppConfig;
